module.exports = __webpack_public_path__ + "static/media/0210_Medium.42954fe0.jpg";